module.exports = __webpack_public_path__ + "static/media/Nico_Luce_mood.84fb1713.jpg";